import { render } from "./index.vue?vue&type=template&id=55a2c1c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=55a2c1c0&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a2c1c0"]])

export default __exports__